import { Routes } from '@angular/router';
import { BuyerLogoutComponent } from './components/buyer-logout/buyer-logout.component';
import { LogoutGuard } from './guards/logout.guard';
import { BuyerLoginCheckGuard } from './buyer-core/buyer-authentication/buyer-guards/buyer-login-check.guard';
import { WildcardErrorComponent } from 'src/app/Shared/components/wildcard-error/wildcard-error.component';
// import { logoutGuard } from './guards/logout.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [BuyerLoginCheckGuard],
    loadChildren: () =>
      import(
        './buyer-core/buyer-authentication/buyer-authentication.routes'
      ).then((r) => r.routes),
  },

  {
    path: 'logout',
    // resolve: { action: LogoutResolver },
    canActivate: [LogoutGuard],
    component: BuyerLogoutComponent,
  },
  {
    path: '',

    loadChildren: () =>
      import('./buyer-core/buyer-layout/buyer-layout.routes').then(
        (r) => r.routes
      ),
  },
  {
    path: '**',
    component: WildcardErrorComponent,
  },
];
